import React, { Component } from "react";

import { CBadge, CButton } from "@coreui/react";

class Banner extends Component {
  render() {
    return (
      <div className="c-banner p-2 text-white">
        <div className="icon-container mr-2">
          <i className="fa fa-check-square"></i>
        </div>
        <div className="flex-1">
          <strong>Aula de matemática</strong> está acontecendo agora!{" "}
          <CBadge color="danger" className="ml-2 font-weight-bold">
            AO VIVO
          </CBadge>
        </div>
        <CButton color="banner" className="btn-sm" onClick={this.props.onClick}>
          Entrar
        </CButton>
      </div>
    );
  }
}

export default Banner;
